<template>
    <footer>
        Copyright {{ new Date().getFullYear() }} <br> Made with 🖤 in Paris, 🇫🇷 🥖 🍷 by <a href="https://www.blacksmith.studio">Blacksmith</a>
    </footer>
</template>

<script>
export default {
    name: 'component-footer'
}    
</script>